
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { usePromotionPlanList } from '@/modules/promotion/plan/model/list';
import { Options } from '@/modules/promotion/plan/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.PLAN.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = usePromotionPlanList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Id', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Item',
                    key: 'linkedItemName',
                    to: row => row.linkedItemLink
                },
                { type: TableColumnType.Option, label: 'Item Type', key: 'type', options: Options.Type },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: Options.Status },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.DateTime, label: 'Publish Time', key: 'publishTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_PROMOTION.PLAN.EDIT, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PROMOTION.PLAN.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_PROMOTION.PLAN.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onclick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable && row.status === 0,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_PROMOTION };
    }
});
